import { render, staticRenderFns } from "./Slider1.vue?vue&type=template&id=053ee19c&scoped=true&"
import script from "./Slider1.vue?vue&type=script&lang=js&"
export * from "./Slider1.vue?vue&type=script&lang=js&"
import style0 from "./Slider1.vue?vue&type=style&index=0&id=053ee19c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ee19c",
  null
  
)

export default component.exports